import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

import { PARTYTOWN_GTM_CONTAINER_ID } from './partytown-config'

export function usePartytownRumContext(): void {
  useEffect(() => {
    // eslint-disable-next-line i18next/no-literal-string
    const partytownReadyEvent = 'pt0'
    const setPartytownRumState = (state: boolean | 'fallback') => {
      try {
        datadogRum.setGlobalContextProperty('partytownWorkerEngaged', state)
      } catch {
        // RUM context must never affect page correctness.
      }
    }
    const classifySettledRuntime = () => {
      const scripts = Array.from(document.scripts).filter(
        script =>
          script.src.includes(PARTYTOWN_GTM_CONTAINER_ID) || script.textContent.includes(PARTYTOWN_GTM_CONTAINER_ID),
      )
      const fellBack = scripts.some(script => Boolean(script.src) && !script.type.startsWith('text/partytown'))
      const workerEngaged =
        scripts.some(script => script.type === 'text/partytown-x') &&
        Boolean(document.querySelector('iframe[src*="partytown-sandbox"]'))
      setPartytownRumState(fellBack ? 'fallback' : workerEngaged)
    }

    setPartytownRumState(false)
    document.addEventListener(partytownReadyEvent, classifySettledRuntime, { once: true })
    const settledRuntimeTimer = window.setTimeout(classifySettledRuntime, 14_000)
    return () => {
      document.removeEventListener(partytownReadyEvent, classifySettledRuntime)
      window.clearTimeout(settledRuntimeTimer)
    }
  }, [])
}
